import React from 'react';
import { IconProps } from './type';
import { cn } from '../../utils/cn';

export const LoadingIcon = ({
  color = 'currentColor',
  spin = true,
  ...props
}: IconProps & { spin?: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      className={cn(props.className, {
        'animate-spin': spin,
      })}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.175 5.825C15.175 5.36936 15.5444 5 16 5C18.1756 5 20.3023 5.64514 22.1113 6.85383C23.9202 8.06253 25.3301 9.78049 26.1627 11.7905C26.9952 13.8005 27.2131 16.0122 26.7886 18.146C26.3642 20.2798 25.3165 22.2398 23.7782 23.7782C22.2398 25.3165 20.2798 26.3642 18.146 26.7886C16.0122 27.2131 13.8005 26.9952 11.7905 26.1627C9.78049 25.3301 8.06253 23.9202 6.85383 22.1113C5.64514 20.3023 5 18.1756 5 16C5 15.5444 5.36937 15.175 5.825 15.175C6.28063 15.175 6.65 15.5444 6.65 16C6.65 17.8493 7.19837 19.657 8.22576 21.1946C9.25315 22.7322 10.7134 23.9306 12.4219 24.6383C14.1304 25.3459 16.0104 25.5311 17.8241 25.1703C19.6378 24.8096 21.3038 23.9191 22.6114 22.6114C23.9191 21.3038 24.8096 19.6378 25.1703 17.8241C25.5311 16.0104 25.3459 14.1304 24.6383 12.4219C23.9306 10.7134 22.7322 9.25315 21.1946 8.22576C19.657 7.19837 17.8493 6.65 16 6.65C15.5444 6.65 15.175 6.28063 15.175 5.825Z"
        fill={color}
      />
    </svg>
  );
};
